import { type ReactNode } from 'react';
import type { Cfg } from '../hooks/use-settings-state';
import { NumField, SelField } from './settings-field';

type Set = (k: keyof Cfg, v: string | number | boolean) => void;

const PERIODS = [
  { value: 'weekly', label: 'Semanal' },
  { value: 'monthly', label: 'Mensual' },
];

export function GoalFields({ cfg, set }: { cfg: Cfg; set: Set }): ReactNode {
  return (
    <>
      <NumField
        label="Objetivo semanal"
        value={cfg.weekly_goal}
        onChange={(v) => set('weekly_goal', v)}
        tip="Meta semanal del equipo para el bonus de equipo"
      />
      <NumField
        label="Objetivo total"
        value={cfg.total_goal}
        onChange={(v) => set('total_goal', v)}
      />
    </>
  );
}

export function Top3Fields({ cfg, set }: { cfg: Cfg; set: Set }): ReactNode {
  return (
    <>
      <NumField
        label="1º puesto"
        value={cfg.bonus_1}
        onChange={(v) => set('bonus_1', v)}
        unit="$"
      />
      <NumField
        label="2º puesto"
        value={cfg.bonus_2}
        onChange={(v) => set('bonus_2', v)}
        unit="$"
      />
      <NumField
        label="3º puesto"
        value={cfg.bonus_3}
        onChange={(v) => set('bonus_3', v)}
        unit="$"
      />
    </>
  );
}

export function PeriodFields({ cfg, set }: { cfg: Cfg; set: Set }): ReactNode {
  return (
    <>
      <SelField
        label="Periodo de ranking"
        value={cfg.ranking_period}
        onChange={(v) => set('ranking_period', v)}
        options={PERIODS}
      />
      <SelField
        label="Periodo de bonus"
        value={cfg.bonus_period}
        onChange={(v) => set('bonus_period', v)}
        options={PERIODS}
      />
    </>
  );
}
